'use client';

import React from 'react';
import ParkingAvailabilityWidget from '../../parking-availability/ui/ParkingAvailabilityWidget';

export default function ParkingAvailabilityWidgetWrap() {
	return <ParkingAvailabilityWidget />;
}
